import { Link } from 'react-router-dom';

export function Header() {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="container">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/logo.png"
              alt="My Best Day"
              className="h-8 md:h-10 w-auto"
            />
            <div className="text-xs md:text-sm text-gray-500 border-l border-gray-300 pl-2 ml-2">
              Free Goal Planner
            </div>
          </Link>

          <a
            href="https://mybestday.ai"
            className="text-sm md:text-base text-primary-600 hover:text-primary-700 font-medium"
          >
            Learn More
          </a>
        </div>
      </div>
    </header>
  );
}
